import React from 'react';
import { HashRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import BaseFeature from 'foundation/base/base';
import CategoryApp from 'app/categoryApp/CategoryApp';

class CategoryComponent extends BaseFeature {
  constructor(element) {
    super(element);
    this.element = element;
    this.isInit = false;

    this.init();
  }

  init() {
    if (this.isInit) return;
    this.load();
  }

  load() {
    ReactDOM.render(
      <section className='react-app'>
        <HashRouter>
          <CategoryApp {...this.settings}  />
        </HashRouter>
      </section>, this.element);

  }
}

export default CategoryComponent;
